<template>
  <v-dialog v-model="showModal">
    <div class="content-section">
      <br>
      <h1 class="header-style">
        Add Emergency Contact
      </h1>
      <br>
      <p class="subheader-style">
        Please add your emergency contact details here.
      </p>
      <v-card
        color="#E2E2E2"
        elevation="0"
      >
        <v-card-title>
          <p class="process-header">
            Add Contact
          </p>
        </v-card-title>
        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
          >
            <v-text-field
              v-model="name"
              label="Enter Name*"
              dense
              :rules="[(v) => !!v || 'This field is required']"
              filled
              color="#000000"
              light
              outlined
            />
            <v-text-field
              v-model="phoneNumber"
              type="number"
              label="Enter Number*"
              dense
              :rules="[(v) => !!v || 'This field is required']"
              filled
              color="#000000"
              light
              outlined
            />
            <v-text-field
              v-model="relation"
              label="Enter Your Relation*"
              dense
              :rules="[(v) => !!v || 'This field is required']"
              filled
              color="#000000"
              light
              outlined
            />
          </v-form>
        </v-card-text>
      </v-card>
      <br>
      <v-btn
        class="btn-style"
        color="#37474F"
        elevation="0"
        @click="addEmergencyContact()"
      >
        Add Contact
      </v-btn>
      <v-btn
        class="btn-style grey-button"
        color="#E2E2E2"
        elevation="0"
        @click="showModal = false"
      >
        Cancel
      </v-btn>
      <center-spinner
        :loading="loading"
      />
    </div>
  </v-dialog>
</template>

<script>
import spinner from '../../components/SpinnerCentre.vue';
import Constants from 'src/constants';

    export default {
        name: 'AddEmergencyContact',
        components: {
            'center-spinner': spinner,
        },
        data: () => ({
            loading: false,
            showModal: true,
            valid: false,
            name: '',
            phoneNumber: '',
            relation: '',
        }),
        watch: {
            showModal: function (newval, oldval) {
                if (newval === false) {
                    this.$emit('closed');
                }
            },
        },
        methods: {
            addEmergencyContact () {
                if (this.$refs.form.validate() === false) {
                    this.$store.dispatch('alert/onAlert', {
                        message: 'Please fill the required fields before proceeding',
                        type: Constants.ALERT_TYPE_ERROR,
                    }, { root: true });
                    return;
                }
                this.loading = true;
                this.$store.dispatch('register/emergencyContacts', {
                        name: this.name,
                        phone_number: this.phoneNumber,
                        relation: this.relation,
                }).then(() => {
                    this.$store.dispatch('alert/onAlert', {
                        message: 'Emergency contact added successfully.',
                        type: Constants.ALERT_TYPE_SUCCESS,
                    });
                    this.loading = false;
                    this.showModal = false;
                }).catch(errors => {
                    this.loading = false;
                });
            },
        },
    };
</script>

<style scoped>
.content-section{
    height: 65vh;
}
</style>
